import React from "react";

interface LottiePlayerButtonProps {
  isPlaying: boolean;
  progress: number;
  onClick: () => void;
  ariaLabel: string;
  className?: string;
}

export const LottiePlayerButton: React.FC<LottiePlayerButtonProps> = ({
  isPlaying,
  progress,
  onClick,
  ariaLabel,
  className = "",
}) => {
  const circumference = 2 * Math.PI * 16; // radius of 16
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={`absolute bottom-4 left-4 w-10 h-10 bg-black/20 hover:bg-black/30 rounded-full flex items-center justify-center text-white transition-colors duration-200 z-10 pointer-events-auto cursor-pointer ${className}`}
      aria-label={ariaLabel}
      style={{ pointerEvents: "auto" }}
    >
      {/* Progress ring */}
      <svg className="absolute inset-0 w-full h-full -rotate-90 pointer-events-none" viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="16" stroke="rgba(255,255,255,0.2)" strokeWidth="2" fill="transparent" />
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="rgba(255,255,255,0.8)"
          strokeWidth="2"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.1s ease" }}
        />
      </svg>

      {/* Play/Pause icon */}
      {isPlaying ? (
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="relative z-10 pointer-events-none"
        >
          <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
        </svg>
      ) : (
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="relative z-10 pointer-events-none"
        >
          <path d="M8 5v14l11-7z" />
        </svg>
      )}
    </button>
  );
};
